// extracted by mini-css-extract-plugin
module.exports = {"wjigro0":"wjigro0"};